

import {useContext, useEffect, useState} from 'react';
import FlujosAddressComplementContext from 'context/FlujosAddressComplementContext';
import {
 getAll,
 create,
 update,
 del
} from 'services/FlujosAddressComplementService.js'
import Swal from 'sweetalert2'


let totalPages;


export function useFlujosAddressComplement(){
 const [page, setPage] = useState(1);
 const [itemsPerPage, setItemsPerPage] = useState(5)

 const {
  allFlujosAddressComplement, 
  setAllFlujosAddressComplement,
  flujosAddressComplement, 
  setFlujosAddressComplement, 
  setMessage, 
  message,
  loading, 
  setLoading} = useContext(FlujosAddressComplementContext);

 
 const getAllFlujosAddressComplement = async ({nivel}) => {
  try{
   const response = await getAll({nivel});
   setAllFlujosAddressComplement(response)
   return response
  }catch(err){
   const {data, status} = err.response;
   setMessage({message: data.message, status});
  }
 }

 const getFlujosAddressComplement = async ({page = 1, limit = itemsPerPage, nivel}) => {
     setLoading(true);
     setPage(page);
     try{
         const allFlujosAddressComplement = await getAllFlujosAddressComplement({nivel});
         console.log({allFlujosAddressComplement})
         setAllFlujosAddressComplement(allFlujosAddressComplement);
         totalPages = Math.ceil(allFlujosAddressComplement.length / limit);
         const flujosAddressComplement = await getAll({page, limit, nivel});
         setFlujosAddressComplement(flujosAddressComplement);
         setLoading(false);
     }catch(err){
         console.log(err);
         const {data, status} = err.response;
         setMessage({message: data.message, status})
         setLoading(false);
     }
 }

 const deleteFlujoAddressComplement = async ({id}) => {
     Swal.fire({
     title: 'Estás seguro?',
     text: '¡No podrás revertir esto!',
     icon: 'warning',
     showCancelButton: true,
     confirmButtonColor: '#3085d6',
     cancelButtonColor: '#d33',
     confirmButtonText: 'Si, eliminar!',
     cancelButtonText: 'Cancelar'
     }).then((result) => {
     if (result.isConfirmed) {
        (async() => {
            try{
                const {message} = await del({id})
                setMessage({message: '', status: 200})
                
                Swal.fire(
                'Éxito!!!',
                message,
                'success'
                )
                getFlujosAddressComplement({page})
            }catch(err){
                const {data, status} = err.response
                setMessage({message: data.message, status})
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: data.message,
                })
            }
        })();
    }
    })
 }

 const updateFlujoAddressComplement = async ({flujo, id}) => {
    try{
        const {message} = await update({flujo, id})
        setMessage({message: '', status: 200})
        Swal.fire(
        'Éxito!!!',
        message,
        'success'
        )
        getFlujosAddressComplement({page})
        return ''
     }catch(err){
        const {data, status} = err.response
        setMessage({message: data.message, status})
        return status
     }
 }

 const createFlujoAddressComplement = async ({flujo}) => {
     try{
        const {message} = await create({flujo})
        setMessage(state => ({...state, message}))
        Swal.fire(
        'Éxito!!!',
        message,
        'success'
        )
        getFlujosAddressComplement({page})
        return ''
     }catch(err){
        const {data, status} = err.response
        setMessage({message: data.message, status})
        return status
     }
 }

 useEffect(() => {
  getFlujosAddressComplement({});
  // eslint-disable-next-line
 }, [])

 return {
        allFlujosAddressComplement, 
        flujosAddressComplement, 
        page, 
        totalPages, 
        status: message.status, 
        loading, 
        deleteFlujoAddressComplement, 
        updateFlujoAddressComplement, 
        createFlujoAddressComplement, 
        getFlujosAddressComplement, 
        setPage,
        itemsPerPage, 
        setItemsPerPage,
    }
}